module.exports = __webpack_public_path__ + "img/松花.f9164d45.jpg";